import { useActivoById } from "api/Activo.hook"
import { useTranslation } from "react-i18next"
import { useParams } from "react-router-dom"
import { frontendCurrency } from "utils/formatCurrency"

export const ResumenAmortizacion = () => {
  const { t } = useTranslation()
  const { activoId } = useParams<{ activoId: string }>()
  const { activoByIdData } = useActivoById(activoId)
  return (
    <div className='tw-bg-white tw-rounded-lg tw-p-6 tw-min-w-80 tw-shadow-sm'>
      <p className='tw-font-medium tw-text-lg tw-mb-auto tw-pb-5'>
        {t("nsAssets.resumenAmortizacion.title")}
      </p>
      <div className='tw-table tw-w-full tw-text-base'>
        <div className='tw-table-row'>
          <div className='tw-table-cell'>
            {t("nsAssets.resumenAmortizacion.initialValue")}
          </div>
          <div className='tw-table-cell tw-text-2xl tw-font-medium tw-text-right tw-pb-4'>
            {frontendCurrency(
              activoByIdData?.resumenAmortizacion?.valorInicial ?? 0
            )}
          </div>
        </div>
        <div className='tw-table-row tw-py-6'>
          <div className='tw-table-cell'>
            {t("nsAssets.resumenAmortizacion.amortized")}
          </div>
          <div className='tw-table-cell tw-text-2xl tw-font-medium tw-text-right tw-pb-4'>
            {frontendCurrency(
              activoByIdData?.resumenAmortizacion?.amortizado ?? 0
            )}
          </div>
        </div>
        <div className='tw-table-row'>
          <div className='tw-table-cell'>
            {t("nsAssets.resumenAmortizacion.currentValue")}
          </div>
          <div className='tw-table-cell tw-text-2xl tw-font-medium tw-text-right'>
            {frontendCurrency(
              activoByIdData?.resumenAmortizacion?.valorNeto ?? 0
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
